import React from "react";
export class FirstLook extends React.Component {
    get isMounted() {
        return this._isMounted;
    }
    set isMounted(value) {
        this._isMounted = value;
    }
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            usersCount: 0,
            dataIsLoaded: false,
        };
    }
    componentWillUnmount() {
        this.isMounted = false;
    }
    async componentDidMount() {
        this.isMounted = true;
    }
    render() {
        return (React.createElement("div", { className: "first_look-container" },
            React.createElement("div", { className: "first-look-text" },
                React.createElement("div", { className: "photographer-text-container" },
                    React.createElement("h3", null,
                        React.createElement("span", { className: "text-primary-color" }, "Fotohub"),
                        " pomaga sprzedawa\u0107 zdj\u0119cia w internecie")),
                React.createElement("p", null,
                    "Tw\u00F3rz i udost\u0119pniaj galerie ze zdj\u0119ciami",
                    React.createElement("br", null),
                    "w kt\u00F3rych klienci mog\u0105 zamawia\u0107 fotografie i op\u0142aca\u0107 zam\u00F3wienie online."))));
    }
}
